import type { PrivyClientConfig } from '@privy-io/react-auth';

/**
 * Default Privy config — tuned for Butter internal ops tools.
 * Override fields by passing `privyConfigOverride` to <PrivyAuthProvider>.
 */
export const DEFAULT_PRIVY_CONFIG: PrivyClientConfig = {
  loginMethods: ['wallet'],
  embeddedWallets: {
    // Privy v3 split this per-chain; we disable for both.
    ethereum: { createOnLogin: 'off' },
    solana: { createOnLogin: 'off' },
  },
  appearance: {
    theme: 'dark',
    accentColor: '#3b82f6',
    showWalletLoginFirst: true,
    walletChainType: 'ethereum-only',
    // Show only what users actually have:
    //   `detected_ethereum_wallets` — auto-renders every EIP-6963 browser
    //     extension installed (MetaMask, OKX, Rabby, Coinbase, Trust, …).
    //     Don't list specific wallets explicitly — Privy ends up showing
    //     them whether or not the extension is installed, which is noisy.
    //   `wallet_connect_qr` — fallback for mobile / no-extension users.
    //     Requires WC project ID on Privy Dashboard (already set for this app).
    walletList: [
      'detected_ethereum_wallets',
      'wallet_connect_qr',
    ],
  },
};

/**
 * Read the central login URL from env. Return null if empty or not set.
 * Apps that set VITE_LOGIN_URL will delegate login to that URL;
 * apps that leave it empty will render an inline LoginPage.
 */
export function readCentralLoginUrl(): string | null {
  const raw = (import.meta as any).env?.VITE_LOGIN_URL as string | undefined;
  if (!raw || raw.trim() === '') return null;
  return raw.trim();
}
